<template>
    <div>
        <div class="customer-list">
            <el-row class="scheme-block">
                <ul v-for="(item, index) in tabList" :key="index">
                    <li @click="activeTabChange(index)" :class="[activeTab === index ?'active': '', !pageList[index] || !pageList[index].status ? 'no-active': '']">{{ item }}</li>
                </ul>
                <el-input
                    class="input-new-tag"
                    v-if="inputVisible"
                    v-model="inputName"
                    ref="saveTagInput"
                    size="small"
                    maxlength="10"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
                >
                </el-input>
                <el-button class="input-new-tag-btn" size="medium" type="primary" icon="el-icon-plus" :disabled="tabList.length && !form.id" @click="addScheme">新增方案</el-button>
            </el-row>
            <block v-if="activeTab !== null">
                <el-form ref="form" :model="form" label-width="100px">
                    <el-form-item label="是否生效：">
                        <el-radio-group size="medium">
                            <el-switch v-model="form.status" :active-value="1" :inactive-value="0"></el-switch>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="设置金额：">
                        <el-input
                                class="way-item-input"
                                size="medium"
                                v-model="form.amount"
                                maxlength="7"
                                placeholder="多少"
                            ></el-input>
                    </el-form-item>
                    <el-form-item label="生效人群：">
                        <el-radio-group v-model="form.targetUser" size="medium">
                            <el-radio :label="1">全部用户</el-radio>
                            <el-radio :label="2">部分用户</el-radio>
                        </el-radio-group>
                        <div v-if="form.targetUser == 2">
                            <div class="coupans-way-item">
                                <el-button size="mini" type="primary" icon="el-icon-plus" plain style="width: 182px;" @click="addDrawerBox(1)">添加个人用户</el-button>
                                <el-button size="mini" type="primary" plain style="width: 122px;" @click="updownExcel(1)">导入个人Excel</el-button>
                                <div class="tips-number" v-if="personalNumber != 0" >已选择个人用户{{personalNumber}}位<span @click.stop="deleteCouponAccountFun(1)"><svg t="1614240680020" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="2103" width="16" height="16"><path d="M174.08 940.8a32 32 0 0 1-22.4-54.4l704-704a32 32 0 0 1 45.44 0 32 32 0 0 1 0 44.8l-704 704a32.64 32.64 0 0 1-23.04 9.6z" fill="#999999" p-id="2104"></path><path d="M878.08 940.8a31.36 31.36 0 0 1-22.4-9.6l-704-704a30.72 30.72 0 0 1 0-44.8 32 32 0 0 1 45.44 0l704 704a32 32 0 0 1 0 44.8 32.64 32.64 0 0 1-23.04 9.6z" fill="#999999" p-id="2105"></path></svg></span></div>
                            </div>
                            <div class="coupans-way-item">
                                <el-button size="mini" type="primary" icon="el-icon-plus" plain style="width: 182px;" @click="addDrawerBox(2)">添加企业用户</el-button>
                                <el-button size="mini" type="primary" plain style="width: 122px;" @click="updownExcel(2)">导入企业Excel</el-button>
                                <div class="tips-number" v-if="enterpriseNumber != 0">已选择企业用户{{enterpriseNumber}}位<span @click.stop="deleteCouponAccountFun(2)"><svg t="1614240680020" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="2103" width="16" height="16"><path d="M174.08 940.8a32 32 0 0 1-22.4-54.4l704-704a32 32 0 0 1 45.44 0 32 32 0 0 1 0 44.8l-704 704a32.64 32.64 0 0 1-23.04 9.6z" fill="#999999" p-id="2104"></path><path d="M878.08 940.8a31.36 31.36 0 0 1-22.4-9.6l-704-704a30.72 30.72 0 0 1 0-44.8 32 32 0 0 1 45.44 0l704 704a32 32 0 0 1 0 44.8 32.64 32.64 0 0 1-23.04 9.6z" fill="#999999" p-id="2105"></path></svg></span></div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="红包奖品配置（顺时针）：">
                        <el-table
                        :data="tableData"
                        border
                        style="width: 362px">
                        <el-table-column
                            prop="multiple"
                            label="倍数"
                            width="180">
                            <template slot-scope="scope">
                                <el-input v-if="editTable" size="mini" 
                                v-model="form.probMultipleList[scope.$index].multiple"
                                onkeyup="value=value.replace(/\D/g,'')"
                                @blur="limitMultiple(scope.$index)"
                                maxlength="3"
                                placeholder="请输入中奖红包倍数"/>
                                <span v-else>{{scope.row.multiple || '--'}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="prob"
                            label="概率"
                            width="180">
                            <template slot-scope="scope">
                                <el-input
                                    v-if="editTable"    
                                    size="mini"
                                    v-model="form.probMultipleList[scope.$index].prob" 
                                    onkeyup="value=value.replace(/\D/g,'')"
                                    @blur="limitNum(scope.$index)"
                                    placeholder="请输入1-100"
                                    maxlength="3"
                                ></el-input>
                                <span v-else>{{scope.row.prob || '--'}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    </el-form-item>
                </el-form>
                
                <el-button size="medium" style="margin: 20px 0;" type="primary" @click="submit">保存</el-button>
                <el-button size="medium" v-if="form.id" type="danger" @click="deleteScheme">删除</el-button>
                <el-button size="medium" v-else type="danger" @click="init()">取消</el-button>
            </block>
        </div>
        <!-- 添加个人/企业 -->
        <el-drawer
            title=""
            :visible.sync="drawer"
            custom-class="add-drawer"
            :with-header="false"
            ref="drawer"
            size="76%"
            :wrapperClosable="false"
        >
            <div class="demo-drawer__content">
                <el-tabs v-model="addUser" type="card" >
                    <el-tab-pane label="个人" name="personal">
                        <PersonalList ref="getp" @onPersonalSubmit="personalNumberFun"/>
                    </el-tab-pane>
                    <el-tab-pane label="企业" name="enterprise">
                        <EnterpriseList ref="gete" @onPersonalSubmit="personalNumberFun"/>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="demo-drawer__footer">
                <template v-if="addUser == 'personal'">
                    <el-button type="primary" @click="addCouponAccountFun(1)">确 定</el-button>
                    <el-button @click="closeDrawer">取 消</el-button>
                </template>
                <template v-else>
                    <el-button type="primary" @click="addCouponAccountFun(2)">确 定</el-button>
                    <el-button @click="closeDrawer">取 消</el-button>
                </template>
            </div>
        </el-drawer>
        <!-- 添加Excel -->
        <el-dialog 
            :visible.sync="excelShow" 
            :title="execlTitle" 
            width="34%" 
            ref="dialog"
            :show-close="false"
            :close-on-click-modal="false"
            append-to-body
        >
            <div>
                <p>1: 文件上传表头为：用户ID、手机号</p>
                <p>2: 上传格式支持XLS</p>
                <p>3: 文件大小不能超过1M；文件最大的上传条数不能超过10000条</p>
                <p>4: 如上传文件格式校验通过，系统自动开始维护库存，请您稍后于任务管理页面查看维护结果</p>
                <!-- <span class="-el-icon-download"></span> -->
                <p style="margin-bottom: 30px;">5: <span class="downLoadTemplate" @click="downLoadTemplate">下载模板 <span class="el-icon-document"></span></span></p>
                <el-upload
                    ref="upload"
                    :data="redEnvDrawParams"
                    :action="actionUrl"
                    :file-list="fileList"
                    :on-success="onUploadSuccess"
                    :on-error="onUploadError"
                    :on-change="onUploadChange"
                    :on-remove="onUploadRemove"
                    :limit="1"
                    accept=".csv, .xls,.xslx,.xlsx"
                    :auto-upload="false">
                    <el-button slot="trigger" size="mini" type="primary" :disabled="!isExeclSubmitDisabled">选取文件</el-button>
                </el-upload>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" type="primary" @click="submitUpload" :disabled="isExeclSubmitDisabled" :loading="isExeclSubmitLoading">确 定</el-button>
                <el-button size="small" @click="clearFilesFun">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { 
  getStorageToken,
} from '@/utils/store'
import PersonalList from '../coupons/index/personalList'
import EnterpriseList from '../coupons/index/enterpriseList'
import {
    redEnvDrawList,  //获取列表
    redEnvDrawAdd,
    redEnvDrawDel,
    redEnvDrawUserAdd,
    redEnvDrawUserDel
} from "@/service/run";
import { getStorageAdminUser } from '@/utils/store'

export default {
    components: {
        PersonalList,
        EnterpriseList
    },
    data() {
        return {
            userInfo: getStorageAdminUser(),
            form: {
                name: '',
                status: 0,
                amount: null,
                targetUser: 1,
                probMultipleList: []
            },
            firstForm: {
                name: '',
                status: 0,
                amount: null,
                targetUser: 1,
                probMultipleList: [{
                    prob: 1,
                    multiple: 1,
                    colour: '#9e9e9ea1'
                }, {
                    prob: 1,
                    multiple: 1,
                    colour: '#9e9e9ea1'
                },{
                    prob: 1,
                    multiple: 1,
                    colour: '#9e9e9ea1'
                },
                {
                    prob: 1,
                    multiple: 1,
                    colour: '#b035c5ab'
                },{
                    prob: 1,
                    multiple: 1,
                    colour: '#b035c5ab'
                },{
                    prob: 1,
                    multiple: 1,
                    colour: '#b035c5ab'
                },

                 {
                    prob: 1,
                    multiple: 1,
                    colour: '#fbbf0bbf'
                },{
                    prob: 1,
                    multiple: 1,
                    colour: '#fbbf0bbf'
                }]
            },
            drawer: false,
            addUser: 'personal',
            personalNumber: 0,
            enterpriseNumber: 0,
            //上传
            excelShow: false,
            fileList: [],

            actionUrl: '',
            isExeclSubmitDisabled: true,
            isExeclSubmitLoading: false,
            execlTitle: '',

            tableData: [{
                id: 399,
                prob: 0.5,
                multiple: '33',
                colour: '#c472b3'
            }, {
                id: 400,
                prob: 0.3,
                multiple: '66',
                colour: '#72c4a8'
            }, {
                id: 401,
                prob: 0.2,
                multiple: '99',
                colour: '#FFC107'
            }],
            editTable: true,
            activeTab:  null,
            tabList: [],
            inputName: '', //方案
            inputVisible: false, // 方案输入框
            pageList: [],
            redEnvDrawParams: {}
        }
    },
    created() {
        this.init();
    },
    methods: {
        init(activeTab) {
            this.redEnvDrawListFun(activeTab);
        },
        submit() {
            if(!this.form.id) {
                this.form.createAccountId = this.userInfo.role_id;
                this.form.createAccountName = this.userInfo.nickname;
            }
            this.form.updateAccountId = this.userInfo.role_id;
            this.form.updateAccountName = this.userInfo.nickname;
            this.redEnvDrawAddFun();
            
        },
        activeTabChange(index) {
            this.activeTab = index;
            this.showPageItem(index)
        },
        addScheme() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleInputConfirm() {
            let inputName = this.inputName;
            if (inputName) {
                this.tabList.push(inputName);
                this.activeTab = this.tabList.length -1;
                this.form = this.firstForm;
                this.form.name = inputName;
                this.tableData = this.firstForm.probMultipleList;
                this.editTable = true;
                this.personalNumber = 0;
                this.enterpriseNumber = 0;
            }
            this.inputVisible = false;
            this.inputName = '';
        },
        deleteScheme() {
            this.$confirm('确定删除吗？').then(() => {
                this.redEnvDrawDelFun();
            });
        },
        //列表
        redEnvDrawListFun(activeTab) {
            redEnvDrawList().then(res=> {
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                if(res.Data.length) {
                    this.pageList = res.Data;
                    let lastIndex = activeTab ? activeTab :  this.pageList.findLastIndex(item=> item.status == 1) ;
                    this.showPageItem(lastIndex == -1 ? 0 :lastIndex , res.Data)
                }else {
                    this.pageList = [];
                    this.form = {}
                    this.tabList = [];
                    this.activeTab = null;
                }
            })
        },
        showPageItem(index, list = this.pageList) {
            console.log("list",list);
            this.form = JSON.parse(JSON.stringify(list[index]));
            this.tableData = list[index].probMultipleList;
            this.activeTab = index;
            this.tabList = list.map(item=> item.name);
            this.editTable = true;

            this.personalNumber = list[index].drawUserList.filter(item=> item.userId).length
            this.enterpriseNumber = list[index].drawUserList.filter(item=> item.companyId).length

            console.log('tabList',this.tabList, this.tableData, this.activeTab);
        },
        redEnvDrawAddFun() {
            this.form.amount = Number(this.form.amount)
            this.form.probMultipleList = this.form.probMultipleList.map(item=> {
                return {
                    prob: Number(item.prob) || 0,
                    multiple: Number(item.multiple) || 0,
                    colour: item.colour
                }
            })
            if(!this.form.amount) {
                this.$message.error('请输入设置金额且不能为0')
                return ;
            }
            let allNum = this.form.probMultipleList.reduce((sum, value) => {return sum + Number(value.prob)}, 0)
            if(allNum !== 100) {
                this.$message.error('概率之和不等于100，请修改后重新提交')
                return ;
            }
            redEnvDrawAdd(this.form).then(res=> {
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.$message.success('提交成功！')
                this.init(this.activeTab);
            })
        },
        redEnvDrawDelFun() {
            let drawConfigId = this.form.id;
            redEnvDrawDel({drawConfigId}).then(res=> {
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.$message.success('删除成功！')
                this.init();
            })
        },
        addDrawerBox(type){
            this.drawer=true;
            if(type==1) {
                this.addUser='personal'
            }else {
                this.addUser='enterprise'
            }
            this.$nextTick(() => {
                this.$refs.getp.handleSearch('redEnvDraw')
                this.$refs.gete.handleSearch('redEnvDraw')
            })
        },
        //添加用户
        addCouponAccountFun(type){
            if(type==1) {
                this.$refs.getp.addCouponAccountPersonalFun('redEnvDraw')
            }else{
                this.$refs.gete.addCouponAccountPersonalFun('redEnvDraw')
            }
        },
        personalNumberFun(val){
            console.log("val",val)
            let params = {
                accountIdList: val.AccountIdList,
                type: val.UserType,
                createAccountId: this.userInfo.role_id,
                createAccountName: this.userInfo.nickname,
                drawConfigId: this.form.id
            };
            redEnvDrawUserAdd(params).then(res=> {
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.$message.success('操作成功！')
                if(params.type === 1) {
                    this.personalNumber = val.AccountIdList.length
                }
                if(params.type === 2) {
                    this.enterpriseNumber = val.AccountIdList.length
                }
                this.drawer=false;
                this.$nextTick(() => {
                    this.$refs.getp.handleReset()
                    this.$refs.gete.handleReset()
                })
            })
        },
        //关闭drawer
        closeDrawer(){
            this.drawer=false;
            this.$nextTick(() => {
                this.$refs.getp.handleReset()
                this.$refs.gete.handleReset()
            })
        },
        updownExcel(type){
            let url = process.env.NODE_ENV == 'development' ? '/api2/service' : process.env.VUE_APP_API2
            this.excelShow = true;
            if(type == 1)  {
                this.execlTitle = '添加个人Execl'
            }else{
                this.execlTitle = '添加企业Execl'
            }
            this.redEnvDrawParams = {
                createAccountId: this.userInfo.role_id,
                createAccountName: this.userInfo.nickname,
                drawConfigId: this.form.id,
                type
            }
            this.actionUrl = url + '/redEnvDraw/excelImport';
        },
        onUploadChange(){
            this.isExeclSubmitDisabled = false
        },
        onUploadRemove(){
           this.isExeclSubmitDisabled = true
        },
        //清空上传
        clearFilesFun(){
            this.excelShow = false;
            this.isExeclSubmitDisabled = true;
            this.isExeclSubmitLoading = false;
            this.$refs.upload.clearFiles();
        },
        //上传
        submitUpload() {
            this.$refs.upload.submit();
        },
        //上传成功
        onUploadSuccess(response, file){
            this.isExeclSubmitLoading = true
            const isLt1M = file.size /1024/1024 < 1;
            let name = file.name;
            let type = name.substring(name.lastIndexOf('.')+1);
            let is = type == 'csv' || type == 'xls' || type == 'xslx' || type == 'xlsx'
            this.isExeclSubmitLoading = false
            if(!is) {
                return this.$message.warning('上传格式支持xls，xslx，xlsx格式的文件！')
            }
            if(!isLt1M) {
                return this.$message.warning('文件大小不能超过1M')
            }
            if(response.Result != 1) {
                return this.$message.error(response.Message)
            }
            this.$message.success("导入成功")
            this.personalNumber = response.Data.userAddedCount
            this.enterpriseNumber = response.Data.companyAddedCount
            setTimeout(() => {
                this.clearFilesFun();
            }, 50);
        },
        //上传失败
        onUploadError(err, file, fileList){
            console.log('失败')
            console.log(err)
            console.log(file)
            console.log(fileList)
        },
        //下载模板
        downLoadTemplate(){
            window.open('https://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/templateDoc/%E7%BA%A2%E5%8C%85%E6%8A%BD%E5%A5%96%E6%A8%A1%E6%9D%BF.xlsx');
        },
        //删除用户
        deleteCouponAccountFun(type) {
            var data = {
                drawConfigId: this.form.id,
                type
            }
            redEnvDrawUserDel(data).then(res=> {
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.$message.success('删除成功！')
                if(type === 1) {
                    this.personalNumber = 0
                }
                if(type === 2) {
                    this.enterpriseNumber = 0
                }
            })
        },
        limitNum(index) {
            let {probMultipleList}  = this.form
            let allNum = probMultipleList.reduce((sum, value) => {return sum + Number(value.prob)}, 0)
            if(allNum>100) {
                this.form.probMultipleList[index].prob = this.form.probMultipleList[index].prob - (allNum-100);
            }
        },
        limitMultiple(index) {
            let {probMultipleList}  = this.form
            probMultipleList.forEach(item => item.multiple = Number(item.multiple) || 1)
            this.form.probMultipleList = probMultipleList
        },
    }
}
</script>
<style lang="scss" scoped>
    .el-tabs__header {
        margin: 0 0 30px;
    }
    .coupans-way-item {
        display: flex;
        justify-content: left;
        align-content: center;
        margin-top: 10px;
        white-space: nowrap;
        .tips-number {
            position: relative;
            margin-left: 30px;
            width: 250px;
            text-align: center;
            background: #F9F9F9;
            line-height: 32px;
            font-size: 14px;
            overflow: hidden;
            transition: All 0.4s ease-in-out;
            -webkit-transition: All 0.4s ease-in-out;
            -moz-transition: All 0.4s ease-in-out;
            -o-transition: All 0.4s ease-in-out;
            border: 1px solid rgba($color: #DCDFE6, $alpha: 0.4);
            border-radius: 4px;
            cursor: pointer;
            span {
                position: absolute;
                right: 10px;
                bottom: -3px;
                cursor: pointer;
                transition: All 0.4s ease-in-out;
                -webkit-transition: All 0.4s ease-in-out;
                -moz-transition: All 0.4s ease-in-out;
                -o-transition: All 0.4s ease-in-out;
                transform: scale(0.8);
                -webkit-transform: scale(0.8);
                -moz-transform: scale(0.8);
                -o-transform: scale(0.8);
                -ms-transform: scale(0.8);
                &:hover {
                    transform: scale(1.2);
                    -webkit-transform: scale(1.2);
                    -moz-transform: scale(1.2);
                    -o-transform: scale(1.2);
                    -ms-transform: scale(1.2);
                }
            }
            
            &:hover {
                border-color: rgba($color: #DCDFE6, $alpha: 1.0);
            }
        }
        .el-button {
            height: 34px;
        }
    }
    .way-item-input {
        width: 200px;
    }
    .small-title {
        width: 194%;
        background: #F9F9F9;
        font-size: 14px;
        color: #333333;
        font-weight: 600;
        line-height: 48px;
        padding: 0 30px;
        margin: 20px 0;
    }
    .parcel {
        position: relative;
        span {
            position: absolute;
            line-height: 36px;
            font-size: 14px;
            color: #999999;
            right: 0;
            top: 2px;
            width: 30px;
        }
    }
    .fixed-submit {
        position: fixed;
        right: 50px;
        top: 126px;
    }
    .el-drawer.rtl{
        overflow-y: auto;
    }
    .add-drawer {
        .el-drawer__body {
            padding: 20px;
        }
        .demo-drawer__content {
            display: flex;
            flex-direction: column;
            height: calc(100% - 30px);
            // height: 100%;
        }
        
        .el-drawer__header {
            margin-bottom: -30px;
        }
    }
    .downLoadTemplate {
        cursor: pointer;
    }
    .downLoadTemplate:hover {
        color: #409EFF;
        text-decoration: underline;
    }
    .scheme-block {
        padding: 10px 14px;
        background-color: #f9fafc;
        ul {
            display: inline-block;
            margin: 10px 0;
            li {
                display: inline-block;
                height: 44px;
                line-height: 44px;
                padding: 0 12px;
                font-size: 16px;
                margin: 0 10px;
                border-radius: 5px;
                color: #fff;
                background: #F56C6C;
                min-width: 90px;
                text-align: center;
                box-sizing: border-box;
                cursor: pointer;
                &.no-active {
                    background-color: #909399;
                }
                &.active {
                    height: 60px;
                    line-height: 60px;
                    font-size: 20px;
                    padding: 0 20px;
                    border: none;
                    border-radius: 30px;
                }
            }
        }
    }
    .inline-b {
        display: inline-block;
    }
    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: center;
    }
    .input-new-tag-btn {
        margin-left: 10px;
    }
    .customer-list {
        padding: 16px;
        background: #fff;
        border-radius: 4px;
        min-height: 700px;
    }
    .small-title {
        width: auto;
    }
</style>